import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useSelector } from 'react-redux';
import Intercom from '@intercom/messenger-js-sdk';
import { RootState } from '../../app/store';

const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;

const IntercomChat: React.FC = () => {
  const { user, isAuthenticated } = useAuth0();
  const personalAccount = useSelector(
    (state: RootState) => state.team.personalAccount.record
  );

  // Extract primitives to avoid spurious re-runs when object references change
  const userName = user?.name;
  const userEmail = user?.email;
  const accountId = personalAccount?.id;
  const accountCreatedAt = personalAccount?.createdAt;
  const intercomToken = personalAccount?.intercom_token;

  useEffect(() => {
    if (!INTERCOM_APP_ID) return;

    const settings: Parameters<typeof Intercom>[0] = {
      app_id: INTERCOM_APP_ID,
    };

    if (isAuthenticated && userEmail && accountId) {
      settings.user_id = accountId;
      settings.name = userName || userEmail.split('@')[0];
      settings.email = userEmail;
      if (accountCreatedAt) {
        settings.created_at = Math.floor(
          new Date(accountCreatedAt).getTime() / 1000
        );
      }
      if (intercomToken) {
        settings.intercom_user_jwt = intercomToken;
      }
    }

    Intercom(settings);

    return () => {
      window.Intercom?.('shutdown');
    };
  }, [
    isAuthenticated,
    userName,
    userEmail,
    accountId,
    accountCreatedAt,
    intercomToken,
  ]);

  return null;
};

export default IntercomChat;
